const queriesContext = require.context('./', true, /^(?!.*index).*\.js$/);


export default (entities) => queriesContext.keys().reduce((memo, key) => {
  const queriesFile = queriesContext(key).default;
  return { ...memo, ...queriesFile(entities) };
}, {});
